import React, { Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Faqs from './components/faqs/Faqs';

document.addEventListener('DOMContentLoaded', () => {
  const faqsElements = Array.from(document.querySelectorAll('.faqs'));
  faqsElements.forEach((faqsElement) => {
    const { faqs } = JSON.parse(faqsElement.querySelector('script.js-react-on-rails-component').textContent);
    hydrateRoot(
      faqsElement.querySelector('div'),
      <Faqs faqs={faqs} />,
    );
  });

  const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );
});
